import template from './has-electricity.jade';

export default angular
    .module('cian.addForm.hasElectricity', [])
    .directive('cianAfAboutObjectHasElectricity', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller(deviceService) {
            'ngInject';

            this.isMobile = deviceService.isMobile;

            this.items = [{
                text: 'Есть',
                value: true,
            }, {
                text: 'Нет',
                value: false,
            }];
        },
        controllerAs: 'hasElectricity',
        template,
    }))
    .name;
